<template>
  <div :id="id" class="com-rank" :style="{height, width:'100%'}" />
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'PieChart',
  props: {
    id: {
      type: String,
      default: () => 'pieChart'
    },
    dataOptions: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: () => '320px'
    },
    unit: {
      type: String,
      default: () => '人'
    }
  },
  data () {
    return {
      myEchart: '',
      countTotal: [],
      num: 0,
      chooseColor: {}
    }
  },
  watch: {
    // 监测侧边连隐藏显示
    // 'sidebar.opened'() {
    //   setTimeout(() => {
    //     this.myEchart && this.myEchart.resize()
    //   }, 800)
    // },
    dataOptions () {
      if (this.dataOptions.length) {
        this.$nextTick(() => {
          this.initChart()
        })
      }
    }
  },
  mounted () {

    // 监测视口大小
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.myEchart && this.myEchart.resize()
      }, 800)
    })
    this.initChart()
  },
  // beforeDestroy () {
  //   if (this.myEchart?.dispose) {
  //     this.myEchart.dispose()
  //     this.myEchart = null
  //   }
  // },
  methods: {
    initChart () {
      const dataOptionsArray = []
      if (this.dataOptions.length > 0) {
        this.dataOptions.map(item => {
          dataOptionsArray.push({
            name: item.name,
            value: item.total,
            source: item.source
          })
        })
      } else {
        dataOptionsArray.push(
          { name: '暂无数据', value: 0 }
        )
      }

      const colors = {
        1: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#658AFF' // 0% 处的颜色
          }, {
              offset: 1, color: '#3665FC' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        2: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#93EED2' // 0% 处的颜色
          }, {
              offset: 1, color: 'rgba(64, 194, 142, 0.85)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        3: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#A48CFD' // 0% 处的颜色
          }, {
              offset: 1, color: '#6C42FF' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        4: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#FFC56D' // 0% 处的颜色
          }, {
              offset: 1, color: '#F8A815' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        5: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#F5A181' // 0% 处的颜色
          }, {
              offset: 1, color: 'rgba(220, 92, 62, 0.85)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        6: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#22E9F2' // 0% 处的颜色
          }, {
              offset: 1, color: '#04B8D3' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        8: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
              offset: 0, color: '#F5A181' // 0% 处的颜色
          }, {
              offset: 1, color: 'rgba(220, 92, 62, 0.85)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        }
      }

      dataOptionsArray.forEach(v=>{
        v.itemStyle = {
          color: colors[v.source]
        }
        v.label = {
          color: 'rgba(0, 0, 0, 0.65)',
          fontSize: 12
        }
        v.labelLine = {
          lineStyle: {
            color: 'rgba(0, 0, 0, 0.45)'
          }
        }
      })

      // console.log(dataOptionsArray, 9090)
      // this.countTotal = dataOptionsArray.map(item => {
      //   return item.value
      // }).join(',').split(',')
      // this.countTotal.forEach(item => {
      //   this.num += Number(item)
      // })
      this.myEchart = echarts.init(document.getElementById(this.id))
      const winW = document.body.clientWidth
     
      this.myEchart.setOption({
        // color: ['#5881fd', '#6395f9'],
        legend: {
          // top: '12%',
          // right: '20px',
          bottom: '0px',
          // orient: 'vertical',
          itemHeight: 10,
          itemWidth: 10,
          icon: 'circle',
          type: 'scroll'
          // textStyle: {
          //   color: this.chooseColor.titleColor
          // }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}  {d}%'
        },
        series: [
          {
            type: 'pie',
            radius: winW < 1440?['20%', '60%']:['30%', '70%'],
            // left:'-100px',
            top: '-10px',
            avoidLabelOverlap: true,
            // center: ['50%', '45%'],
            // emphasis: {
            //   focus: 'self'
            // },
            
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 1
            },
            label: {
              formatter: '{d}%'
            },
            labelLine: {
              show: true,
              normal: { // 设置引导线长度
                show: true,
                length: 10
              },
              lineStyle: {
                color: 'red'
              }
            },
            // minAngle: 20, // 设置扇区最小角度
            data: dataOptionsArray
          }
        ]
      })
      // this.myEchart.on('click', function (parmas) {
      //   console.log(parmas)
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.com-rank {
  // height: 300px;
  background-color: #fff !important;
}
</style>
